import classNames from 'classnames';
import React from 'react';

import TableSingleInput from 'notebook/structured-tables/single-inputs/TableSingleInput';
import {TableEditableClass} from 'notebook/tables/core-ui/TableEditable';
import {TableHeaderRowProps} from 'notebook/tables/core-ui/TableHeaderRow';
import {TableRowProps} from 'notebook/tables/core-ui/TableRow';
import {RowModelProvider} from 'notebook/tables/store/contexts/RowModelContext';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface TableSingleInputGroupProps {
  sliceStart: number;
  // exclusive
  sliceEnd: number;
  headerRowProps: TableHeaderRowProps;
  rowProps: TableRowProps;
  clearMultiSelect: TableEditableClass['clearMultiSelect'];
}

export default function TableSingleInputGroup(props: TableSingleInputGroupProps): JSX.Element {
  const inputs = [];
  for (let j = props.sliceStart; j < props.sliceEnd; j++) {
    inputs.push(
      <TableSingleInput key={j} j={j} headerRowProps={props.headerRowProps} rowProps={props.rowProps} />
    );
  }

  return (
    <div
      className={classNames('mediocre-tableEditable-singleInputGroup')}
      onClick={props.clearMultiSelect}
      {...getTestProps({component: 'SingleInputGroup', element: 'root'})}
    >
      <RowModelProvider rowIndex={props.rowProps.i}>{inputs}</RowModelProvider>
    </div>
  );
}
